// Generated by scripts/mdi/import-questionnaires.mjs from MDI "B12 Refill 09.17.26" (5ff00db3-3fc3-41cb-8ab5-822de7456e48). Re-run instead of editing.
import { FormType } from '../../../form-types';
import { mdiB12RefillAnswerField } from './questions';

export const mdiB12Refill: FormType<mdiB12RefillAnswerField> = {
  name: 'B12 Refill',
  validityLength: 25,
  questions: [
    'mdiB12Refill_comparedBeforeStartedVitaminB12',
    'mdiB12Refill_last30DaysOftenTaken',
    'mdiB12Refill_sinceLastRefillExperiencedSymptoms',
    'mdiB12Refill_startedNewMedicationsSupplementsSince',
    'mdiB12Refill_changesMedicalHistoryHealthProfile',
    'mdiB12Refill_importantClickAttachedLinkReview',
    'mdiB12Refill_updateDoctor',
    'mdiB12Refill_complete'
  ]
};
